// const prefDomainCode = 'A001101'
// const prefDomainCodeEn = 'A001102'

export default {
  isGroupAdminFlg: state => state.auth.groupAdminFlg === '1',

  isAdminFlg: state => state.auth.adminFlg === '1',

  prefCodeList: state => state.prefCodeList,

  prefNameByCode: state => (prefCode) => {
    const pref = state.prefCodeList
      .find(codeDef => codeDef.kbnCd === ('0' + prefCode).slice(-2))
    return pref ? pref.kbnVal : ''
  },

  localMediaManagementClubCodeList: state => {
    if (state.clubJCodeList) {
      return state.clubJCodeList.concat(state.clubWECodeList)
    }
    return []
  },

  localMediaManagementClubNameByCode: (state, getters) => (clubCode) => {
    const club = getters.localMediaManagementClubCodeList
      .find(codeDef => codeDef.kbnCd === clubCode)
    return club ? club.kbnVal : ''
  },

  fromAddressList: state => state.form.fromAddressList,

  manualUrl: state => state.manualUrl
}
